import Home from '../../views/auth/Home'
import PageNotFound from "../../views/auth/PageNotFound"
import QoosquarePeople from "@/views/website/QoosquarePeople";
export default [
    {
        path: '/',
        name: 'Home',
        meta: {layout: 'auth',authRequired:false},
        component: Home,
    },
    {
        path: '/people',
        name: 'QoosquarePeople',
        meta: {layout: 'auth',authRequired:false},
        component: QoosquarePeople,
    },
    {
        path: '*',
        name: 'PageNotFound',
        meta: {layout: '404',authRequired:false},
        component: PageNotFound,
    }
];
